import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from "@mui/material";

const TmDialog = ({
    open,
    title,
    text,
    answer1,
    answer2,
    onClose,
    onClickAnswer1,
    onClickAnswer2,
}) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{text}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClickAnswer1} color="primary">
                    {answer1}
                </Button>
                <Button onClick={onClickAnswer2} color="secondary">
                    {answer2}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TmDialog;
